import "@fontsource/inter/700.css";
import styled from "styled-components";
import { theme } from "../../../theme";

const Title = styled.div<{ textalign?: string; color?: string }>`
  font-family: "Inter", sans-serif;
  font-size: 36px;
  color: ${(props) => props.color ?? theme.colors.text};
  text-align: ${(props) => props.textalign ?? "left"};
  font-weight: 700;
`;

export default Title;
